module.exports = __webpack_public_path__ + "img/not_started.cef11fe8.svg";